/* global axios */
import ApiClient from './ApiClient';

class MotorReservaRoomsAPI extends ApiClient {
  constructor() {
    super('motor_reserva_rooms', { accountScoped: true });
  }

  addPhoto(roomId, file) {
    const formData = new FormData();
    formData.append('photo', file);
    return axios.post(`${this.url}/${roomId}/add_photo`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  removePhoto(roomId, photoId) {
    return axios.delete(`${this.url}/${roomId}/remove_photo`, {
      params: { photo_id: photoId },
    });
  }

  reorderPhotos(roomId, order) {
    return axios.post(`${this.url}/${roomId}/reorder_photos`, { order });
  }

  getUnits(roomId) {
    return axios.get(`${this.url}/${roomId}/units`);
  }

  createUnit(roomId, unitData) {
    return axios.post(`${this.url}/${roomId}/create_unit`, { unit: unitData });
  }

  updateUnit(unitId, unitData) {
    return axios.put(`${this.url}/${unitId}`, {
      motor_reserva_room: unitData,
    });
  }

  deleteUnit(unitId) {
    return axios.delete(`${this.url}/${unitId}`);
  }
}

export default new MotorReservaRoomsAPI();
